import { EventEmitter } from '@shop/frontend/web/js/components/EventEmitter';
import request from '@shop/frontend/web/js/api/request';
import api from '@shop/frontend/web/js/api';
import { Modal } from '@shop/frontend/web/js/components/Modal';

class BackendError extends Error {
  constructor(message) {
    super(message);
    this.name = 'BackendError';
  }
}

const emitter = new EventEmitter();

const modal = new Modal();

const copyURI = (e) => {
  e.preventDefault();
  const dummy = document.createElement('input');
  const text = window.location.href;

  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand('copy');
  document.body.removeChild(dummy);

  $('#successModal').addClass('success-modal_active');

  setTimeout(() => {
    $('#successModal').removeClass('success-modal_active');
  }, 5000);
};

function transformButtonToBuyButton($btn) {
  $btn.closest('.is-booked').removeClass('is-booked');
  $btn.text('Выкупить');
  $btn.removeClass();
  $btn.addClass('buy-button buy');
}

function transformButtonToBookedButton($btn, uid) {
  $btn.closest('.text-right').addClass('is-booked');
  $btn[0].setAttribute('data-uid', uid);

  $btn.text('В корзине');
  $btn.removeClass('buy');
  $btn.addClass('booked disabled');
}

function makeBtnBooked(buyBtn, btnText) {
  $(buyBtn).removeClass('buy');
  $(buyBtn).addClass('booked disabled');
  $(buyBtn).text(btnText);
}

/** @event holdSeats#event:remove-ticket */
emitter.subscribe('event:remove-ticket', ({
  sid, eventId, uid, onResolve,
}) => {
  api.eventCart
    .removeFromCart({ eventId, sid, uid })
    .then((res) => {
      if (res.error) throw new Error(res.msg);
      if (!res.carts) return false;

      if (window.CartService.count > 0) {
        window.CartService.count -= 1;
        window.CartService.updateCount();
      }

      if (onResolve) {
        onResolve();
      }
    })
    .catch((err) => {
      alert(`Произошла ошибка при удалении из корзины!\n${err.message}`);
      return window.location.reload();
    });
});

$('.container__hotseats').on('click', '.buy', function () {
  const { bookingId, sid, eventId } = $(this).data();
  const key = $('#keySearch').val();
  const eventPrice = +$(this).data('price');

  const data = {
    event_id: eventId,
    key,
    sid,
    ...(bookingId && { hold_id: bookingId }),
  };

  request({
    url: '/hold-seats/add-to-cart',
    addCSRFToken: true,
    data,
  })
    .then((response) => {
      if (response.error === 1) {
        throw new BackendError(response.msg);
      }

      transformButtonToBookedButton($(this), response?.uid);

      const $currentEventItem = $(this.closest('.events__item'));

      $currentEventItem
        .find('.buy-container__clear-button')
        .addClass('buy-container__clear-button_active');

      const $priceSpan = $currentEventItem.find('.js-buy-container-price');
      const curPrice = +$priceSpan.text().split(' ')[0];
      $currentEventItem.find('.js-buy-container-price').text(`${curPrice + eventPrice} ₽`);

      window.CartService.count += 1;
      window.CartService.updateCount();
    })
    .catch((error) => {
      console.log(error);
      if (error.name !== 'BackendError') {
        return modal.show('Ошибка добавления в корзину, попробуйте снова');
      }

      if (error.message.includes('Превышен лимит билетов в заказе')) {
        return modal.show('Вы превысили максимально допустимое количество мест для брони');
      }

      return modal.show(error.message);
    });
});

$('.container__hotseats').on('change', '.button-buy-all', function () {
  const $currentTable = $(this).closest('table');
  const isChecked = $(this).prop('checked');

  const eventId = $currentTable.find('.buy').data('event-id');
  const bookingId = $(this).data('booking-id');
  const key = $('#keySearch').val();
  const sids = [];

  $currentTable.find('.buy').each(function () {
    sids.push(this.dataset.sid);
  });

  if (sids.length === 0 && isChecked) return;

  const data = bookingId
    ? {
      event_id: eventId, key, sids, booking_id: bookingId,
    }
    : { event_id: eventId, key, sids };

  $(this)[0].setAttribute('disabled', true);

  if (isChecked) {
    request({
      url: '/hold-seats/scope-add-to-cart',
      addCSRFToken: true,
      data,
    })
      .then((response) => {
        if (response?.error === 1) {
          const err = new BackendError(response.msg);
          throw err;
        }

        let addedTicketsCount = 0;

        for (const ticketNumber in Object.entries(response.res[0])) {
          const curSid = Object.entries(response.res[0])[ticketNumber][0];
          const curUid = Object.entries(response.res[0])[ticketNumber][1];

          const $buyButton = $(`.buy[data-sid="${curSid}"]`);
          const $currentEventItem = $($buyButton.closest('.events__item'));
          const eventPrice = +$buyButton.data('price');

          if (curUid?.error === 1) {
            makeBtnBooked($buyButton, 'В работе');
          } else {
            transformButtonToBookedButton($buyButton, curUid);

            $currentEventItem
              .find('.buy-container__clear-button')
              .addClass('buy-container__clear-button_active');

            const $priceSpan = $currentEventItem.find('.js-buy-container-price');
            const curPrice = +$priceSpan.text().split(' ')[0];
            $priceSpan.text(`${curPrice + eventPrice} ₽`);

            addedTicketsCount++;
          }
        }

        window.CartService.count += addedTicketsCount;
        window.CartService.updateCount();
      })
      .catch((response) => {
        if (response?.name !== 'BackendError') {
          return modal.show('Ошибка добавления в корзину, попробуйте снова');
        }

        if (response.message.includes('Превышен лимит билетов в заказе')) {
          return modal.show('Вы превысили максимально допустимое количество мест для брони');
        }

        return modal.show(response.message);
      })
      .finally(() => {
        $(this)[0].removeAttribute('disabled');
      });
  } else {
    const $currentEventItem = $(this.closest('.events__item'));
    const uids = [];

    const $priceSpan = $currentEventItem.find('.js-buy-container-price');
    const curPrice = +$priceSpan.text().split(' ')[0];
    let eventsPrice = 0;

    $currentEventItem.find('.booked').each(function () {
      if (!this.closest('.text-right').classList.contains('is-booked')) {
        return;
      }

      uids.push(this.dataset.uid);
      eventsPrice += +this.dataset.price;
    });

    const data = { uids };

    request({
      url: '/event/cart/scope-remove-uid',
      addCSRFToken: true,
      data,
    })
      .then(() => {
        $currentEventItem.find('.booked').each((index, btn) => {
          transformButtonToBuyButton($(btn));
        });

        $priceSpan.text(`${curPrice - eventsPrice} ₽`);

        if ($currentEventItem.find('.is-booked').length === 0) {
          $currentEventItem
            .find('.buy-container__clear-button')
            .removeClass('buy-container__clear-button_active');
        }

        window.CartService.count -= uids.length;
        window.CartService.count = window.CartService.count < 0 ? 0 : window.CartService.count;
        window.CartService.updateCount();
      })
      .catch(() => {
        alert('Ошибка удаления из корзины, попробуйте снова');
      });

    $(this)[0].removeAttribute('disabled');
  }
});

function search() {
  const key = $('#keySearch').val();
  const unitId = $('#unitIdSearch').val();

  const queryParams = new URLSearchParams(window.location.search);
  queryParams.set('key', key);
  if (unitId !== undefined) {
    queryParams.set('unit_id', unitId);
  }
  history.replaceState(null, null, `?${queryParams.toString()}`);

  const data = {
    key,
    unitId,
  };

  request({
    url: '/hold-seats',
    addCSRFToken: true,
    type: 'GET',
    data: {
      key,
      unitId,
    },
  })
    .then((response) => {
      if (key !== '') {
        $('.alert').remove();
      }
      let htmlResponse;
      if (response.eventsSeats.includes('events__empty-hold-seats')) {
        htmlResponse = "<div class='events__empty-hold-seats'> <img class='events__empty-img' src='/images/site/zero_search.svg' alt=''> <p class='events__empty-text mb-0'>По вашему запросу мероприятия не найдены. </p> <p class='events__empty-text mb-0'> Пожалуйста, проверьте правильность введенных данных и повторите снова. </p> <p class='events__empty-text mb-0'>Если ключевое слово введено верно, попробуйте войти чуть позднее. </p> </div>";
      } else {
        htmlResponse = response.eventsSeats;
      }

      $('.events').hide().html(htmlResponse).fadeIn('slow');
    })
    .catch(() => {
      alert('Ошибка поиска, попробуйте снова');
    });
}

$('.btn-search').click(search);

$('#keySearch').keyup((event) => {
  if (event.keyCode === 13) {
    event.preventDefault();
    search();
  }
});

// Функция для удаления билета из корзины
$('.container__hotseats').on('click', '.js-tickets-remove', function (e) {
  const $currentEventItem = $(this.closest('.events__item'));
  const $ticketDeleteBtnWrapper = $(this).parent('.js-delete-ticket-wrapper');

  const $bookedBtn = $ticketDeleteBtnWrapper.siblings('.booked');

  const sid = $bookedBtn.data('sid');
  const uid = $bookedBtn.attr('data-uid');
  const correctSid = sid.split('{')[0];

  const $priceSpan = $currentEventItem.find('.js-buy-container-price');
  const curPrice = +$priceSpan.text().split(' ')[0];
  const eventPrice = $bookedBtn.data('price');

  const eventId = $bookedBtn.attr('data-event-id');

  const onResolve = () => {
    transformButtonToBuyButton($bookedBtn);

    $priceSpan.text(`${curPrice - eventPrice} ₽`);

    if ($currentEventItem.find('.is-booked').length === 0) {
      $currentEventItem
        .find('.buy-container__clear-button')
        .removeClass('buy-container__clear-button_active');
    }
  };

  emitter.emit('event:remove-ticket', {
    sid: correctSid, eventId, uid, onResolve,
  });
});

// Функция для удаления всех билетов из корзины по одному мероприятию
$('.container__hotseats').on('click', '.js-seats-clear-button', function (e) {
  const $currentEventItem = $(this.closest('.events__item'));
  const uids = [];

  const $priceSpan = $currentEventItem.find('.js-buy-container-price');
  const curPrice = +$priceSpan.text().split(' ')[0];
  let eventsPrice = 0;

  $currentEventItem.find('.booked').each(function () {
    if (!this.closest('.text-right').classList.contains('is-booked')) {
      return;
    }

    uids.push(this.dataset.uid);
    eventsPrice += +this.dataset.price;
  });

  const data = { uids };

  request({
    url: '/event/cart/scope-remove-uid',
    addCSRFToken: true,
    data,
  })
    .then(() => {
      $currentEventItem.find('.booked').each((index, btn) => {
        transformButtonToBuyButton($(btn));
      });

      $priceSpan.text(`${curPrice - eventsPrice} ₽`);

      if ($currentEventItem.find('.is-booked').length === 0) {
        $currentEventItem
          .find('.buy-container__clear-button')
          .removeClass('buy-container__clear-button_active');
      }

      window.CartService.count -= uids.length;
      window.CartService.count = window.CartService.count < 0 ? 0 : window.CartService.count;
      window.CartService.updateCount();
    })
    .catch(() => {
      alert('Ошибка удаления из корзины, попробуйте снова');
    });
});

$('.container__hotseats').on('click', '.btn-share', copyURI);
